Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sup = exports.Sub = exports.Small = exports.Paragraph = void 0;

var self_1 = require("./self");

var paragraph_reset_1 = require("./paragraph-reset");

var getExtraAttrs = function getExtraAttrs(props) {
  return {
    'aria-modal': props.ariaModal,
    rel: props.rel,
    role: props.role,
    onClick: props.onClick
  };
};

exports.Paragraph = function (props) {
  var extraAttrs = getExtraAttrs(props);
  return self_1.getSelf(props, paragraph_reset_1.paragraphReset, 'p', extraAttrs);
};

exports.Small = function (props) {
  var extraAttrs = getExtraAttrs(props);
  return self_1.getSelf(props, paragraph_reset_1.paragraphReset, 'small', extraAttrs);
};

exports.Sub = function (props) {
  var extraAttrs = getExtraAttrs(props);
  return self_1.getSelf(props, paragraph_reset_1.paragraphReset, 'sub', extraAttrs);
};

exports.Sup = function (props) {
  var extraAttrs = getExtraAttrs(props);
  return self_1.getSelf(props, paragraph_reset_1.paragraphReset, 'sup', extraAttrs);
};